import { clsx } from "@/utils";
import { readStickyColumn } from "../sticky";
import { DataTableRowProps } from "../types";
import { DataTableCell } from "./DataTableCell";

export const DataTableRow = <T extends object>({ row, children, className, ...props }: DataTableRowProps<T>) => {
  const cells = row.getVisibleCells();
  // A pinned cell carries its own opaque background (it paints over the cells scrolling beneath it), so
  // it has to follow the row's hover state by itself rather than letting the row's colour show through.
  // `group` is what lets it: see STICKY_RIGHT_CELL's `group-hover`. Only marked when a pinned cell is
  // actually present, so every other table keeps its exact current markup.
  const hasStickyColumn = cells.some((cell) => readStickyColumn(cell.column.columnDef));

  return (
    <>
      <tr className={clsx(hasStickyColumn && "group", className)} {...props}>
        {cells.map((cell) => (
          <DataTableCell
            key={cell.id}
            cell={cell}
            className="font-regular px-4 py-2 align-middle text-base text-neutral-black max-lg:p-2"
          />
        ))}
      </tr>
      {children && (
        <tr className="subcomponent border-none">
          <td colSpan={cells.length} className="p-0">
            {children}
          </td>
        </tr>
      )}
    </>
  );
};
